import type React from "react";

type LogoSize = "large" | "medium" | "small";

interface LogoProps {
    size?: LogoSize;
}

const Logo: React.FC<LogoProps> = ({ size = "small" }) => {
    let props;

    switch (size) {
        case "large":
            props = { width: "180", height: "74" };
            break;
        case "medium":
            props = { width: "150" };
            break;
        case "small":
            props = { width: "90", height: "37" };
    }
    return <img alt="Logo" src="/static/images/logo.svg" {...props} />;
};

export default Logo;
